const getDirctionLang = () => {
    const dir = ['ar', "ckb"].includes(localStorage.getItem("lang")) ? "rtl" : "ltr";

    // console.log(dir)
    return dir
};

export default getDirctionLang;